module.exports = __webpack_public_path__ + "img/elem1Image.c2a8ddd2.png";